// extracted by mini-css-extract-plugin
export var notificationHost = "_m6-0";